import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  supportText: {
    marginTop: theme.spacing(1)
  },
  supportedFormats: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  }
}));

export default useStyles;
